(function () {
	function markRichTextSectionsWithoutAnimation() {
		document.querySelectorAll(".rich-text-section").forEach((section) => {
			if (section.querySelector(".rich-text__subheading-animation")) {
				return;
			}

			section.classList.add("js-init");
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener(
			"DOMContentLoaded",
			markRichTextSectionsWithoutAnimation,
		);
	} else {
		markRichTextSectionsWithoutAnimation();
	}

	document.addEventListener(
		"shopify:section:load",
		markRichTextSectionsWithoutAnimation,
		true,
	);
})();
